export default abstract class Service {
    abstract destroy(): void;
}

/**
 * A Service with listeners that must be started on Service activation, and stopped when the Service is moved into the
 * background or removed
 */
export abstract class SubscriptionsService extends Service {
    destroy() {
        this.stopSubscriptions();
    }

    abstract startSubscriptions(): void;
    abstract stopSubscriptions(): void;
}